import { render, staticRenderFns } from "./ExpenseCategories.vue?vue&type=template&id=d27c145a"
import script from "./ExpenseCategories.vue?vue&type=script&lang=js"
export * from "./ExpenseCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports